






































































































































import Vue from 'vue'
import NewYorkCategoryPostTree from '@/components/product/NewYorkCategoryPostTree.vue'
import LessonsStats from '@/components/product/LessonsStats.vue'
import CategorySlider from '@/components/common/CategorySlider.vue'
import { getHeroSpacingClass } from '@/helper/index'

export default Vue.extend({
  components: {
    NewYorkCategoryPostTree,
    LessonsStats,
    CategorySlider
  },
  metaInfo() {
    const meta = {}
    meta['link'] = [
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css?family=Lato',
        vmid: 'newYorkFonts'
      }
    ]
    return meta
  },
  props: {
    heroSection: {
      type: Object
    },
    product: {
      type: Object
    },
    instructor: {
      type: Object
    },
    categoryTree: {
      type: Array
    },
    nextPost: {
      type: Object
    },
    completedPosts: Number,
    totalPosts: Number,
    postIdsCompleted: Set,
    courseCompleted: Boolean,
    productStarted: Boolean,
    logo: String
  },
  data() {
    return {
      styles: '',
      currentCategoryIndex: 0
    }
  },
  computed: {
    brandLogoUrl(): string {
      return this.logo || this.$store.state.logoUrl
    },
    templateId(): string {
      return this.$route.query.template_id
    },
    themeSettings(): object {
      if (
        this.product &&
        this.product.customizations &&
        this.product.customizations.settings
      ) {
        return this.product.customizations.settings.themeSettings
      }
      return null
    },
    sections(): object {
      if (
        this.product &&
        this.product.customizations &&
        this.product.customizations.settings
      ) {
        return this.product.customizations.settings.sections
      }
      return null
    },
    hero(): object {
      return this.sections?.hero
    },
    heroCustomBackground(): boolean {
      const background = this.hero?.background?.background
      if (background) {
        return true
      }
      return false
    },
    heroButton(): object {
      return this.hero?.button
    },
    buttonContent(): object {
      return this.heroButton?.content
    },
    showLogo(): boolean {
      if (this.themeSettings) {
        return this.themeSettings.logoPlacement === 'hero'
      }
      return false
    },
    progressColor(): string {
      let color = '#3b82f6'
      if (this.themeSettings) {
        color = this.themeSettings?.secondaryStyle?.color
      }
      if (this.sections?.lessonProgress?.progressColor) {
        color = this.sections.lessonProgress.progressColor
      }
      return color
    },
    categoryBorder(): string {
      let color = '#3b82f6'
      if (this.themeSettings) {
        color = this.themeSettings?.primaryStyle?.color
      }
      if (this.sections?.courseBody?.category?.color) {
        color = this.sections.courseBody.category?.color || '#3b82f6'
      }
      return color
    },
    heroSpacing(): string {
      if (this.sections?.hero?.background?.spacing) {
        return getHeroSpacingClass(this.sections.hero.background.spacing)
      }
      return null
    }
  },
  methods: {
    handleNextPostClick() {
      this.$emit('goToNextPost')
    },
    changeSelectedCategoryIndex(val: number) {
      this.currentCategoryIndex = val
    }
  }
})
